import GuardianIcon from "@/components/common/GuardianIcon"
import { GuardianIconName } from "@/constants/guardianIconNames"
import {
  dominantDustElement,
  resolveDustElementIcon,
  totalShardDust,
} from "@/constants/shards"
import { DigitalPassport } from "@/types/battle"
import { defaultShardDust } from "@/utils/shardsNormalize"

interface GuardiansHeaderBarProps {
  passport: DigitalPassport
  compact?: boolean
  currenciesOnly?: boolean
}

export default function GuardiansHeaderBar({
  passport,
  compact = false,
  currenciesOnly = false,
}: GuardiansHeaderBarProps) {
  const dust = passport.shardDust ?? defaultShardDust()
  const dustTotal = totalShardDust(dust)
  const dustIcon = resolveDustElementIcon(dominantDustElement(dust))

  return (
    <div className={`w-full ${compact ? "gap-1.5" : "gap-2"} flex flex-col`}>
      <div className={`flex w-full gap-2 ${compact ? "gap-1.5" : ""}`}>
        <CurrencyPill
          assetIcon="chakra"
          value={passport.chakraCharges}
          label="чакры"
          accent
        />
        <CurrencyPill assetIcon="monet" value={passport.coins} label="монеты" />
        <CurrencyPill
          assetIcon="energy"
          value={`${passport.energy}/${passport.maxEnergy}`}
          label="энергия"
          compactValue
        />
      </div>

      {!currenciesOnly && (
        <div className={`flex w-full gap-2 ${compact ? "gap-1.5" : ""}`}>
          <CurrencyPill
            assetIcon="global"
            value={passport.globalPts}
            label="глоб."
          />
          <CurrencyPill icon="📍" value={passport.localPts} label="лок." />
          <CurrencyPill
            imageSrc={dustIcon}
            value={dustTotal}
            label="пыль"
          />
        </div>
      )}
    </div>
  )
}

function CurrencyPill({
  icon,
  assetIcon,
  value,
  label,
  accent,
  imageSrc,
  compactValue,
}: {
  icon?: string
  assetIcon?: GuardianIconName
  value: string | number
  label: string
  accent?: boolean
  imageSrc?: string | null
  compactValue?: boolean
}) {
  return (
    <div
      className={`flex min-w-0 flex-1 flex-row items-center gap-1.5 rounded-xl border px-2.5 py-2.5 ${
        accent
          ? "border-guardians-accent/25 bg-guardians-accent/10"
          : "border-white/10 bg-white/[0.06]"
      }`}
    >
      {assetIcon ? (
        <GuardianIcon name={assetIcon} size={28} />
      ) : imageSrc ? (
        <img src={imageSrc} alt="" width={28} height={28} className="object-contain" />
      ) : (
        <span className="text-xl leading-none">{icon}</span>
      )}
      <div className="min-w-0 flex-1">
        <div
          className={`truncate font-extrabold ${
            compactValue ? "text-[11px]" : "text-sm"
          } ${accent && !compactValue ? "text-guardians-accent" : "text-white"}`}
        >
          {value}
        </div>
        <div className="text-[9px] font-semibold text-white/45">{label}</div>
      </div>
    </div>
  )
}
